<router-outlet />
<div kendoDialogContainer></div>
<kendo-notification-container />
